import types from './actionTypes'
import { PENDING, SUCCESS, FAILURE } from 'constants/configs'

const initialState = {
  currencies: {
    items: [],
    loading: true,
    error: '',
    totalPages: 0,
  },
}

const currencyReducer = (state = initialState, { payload, type }) => {
  let index
  switch (type) {
    case PENDING(types.GET_CURRENCIES):
      return {
        ...state,
        currencies: {
          ...state.currencies,
          loading: true,
        },
      }
    case SUCCESS(types.GET_CURRENCIES):
      return {
        ...state,
        currencies: {
          ...state.currencies,
          items: payload.data,
          totalPages: payload.meta.last_page,
          loading: false,
        },
      }
    case FAILURE(types.GET_CURRENCIES):
      return {
        ...state,
        currencies: {
          ...state.currencies,
          loading: false,
          error: payload,
        },
      }
    case SUCCESS(types.CREATE_CURRENCY):
      return {
        ...state,
        currencies: {
          ...state.currencies,
          items: [...state.currencies.items, payload.data],
        },
      }
    case SUCCESS(types.EDIT_CURRENCY):
      const newItems = state.currencies.items
      index = newItems.findIndex((el) => el.uuid === payload.data.uuid)
      newItems[index] = payload.data
      return {
        ...state,
        currencies: {
          ...state.currencies,
          items: [...newItems],
        },
      }
    case SUCCESS(types.DELETE_CURRENCY):
      index = state.currencies.items.findIndex((el) => el.uuid === payload)
      return {
        ...state,
        currencies: {
          ...state.currencies,
          items: [
            ...state.currencies.items.slice(0, index),
            ...state.currencies.items.slice(index + 1),
          ],
        },
      }
    case SUCCESS(types.CLEAR_CURRENCIES):
      return {
        ...state,
        currencies: {
          items: [],
          loading: true,
          error: '',
          totalPages: 0,
        },
      }
    default:
      return state
  }
}

export default currencyReducer
